module.exports = __webpack_public_path__ + "img/bg_top.604ccdbd.svg";